import React from 'react';
import PropTypes from 'prop-types';
import s from './Box.module.scss';
import classNames from 'classnames';

const Box = ({
    title,
    children,
    className = '',
    modifier = '',
    modifiers = [],
}) => {
    const allModifiers = modifier ? [...modifiers, modifier] : modifiers;
    const classes = classNames(
        s.Root,
        className,
        ...allModifiers.map((m) => s[`Root--${m}`])
    );

    return (
        <div className={classes}>
            {title && <h3 className={s.Title}>{title}</h3>}
            {children}
        </div>
    );
};

Box.propTypes = {
    children: PropTypes.node,
    modifier: PropTypes.string,
};

export default Box;
